module.exports = __webpack_public_path__ + "static/media/harald.02f85fe6.png";